module.exports = __webpack_public_path__ + "827232bc56a1647f7f447c571804602b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GP.svg
// module id = Vn+r
// module chunks = 0